module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon3.756f174c.svg";